import {
    MouseEvent,
    useMemo,
    useState,
} from "react";

import { SearchablePopoverSelectProps } from "./searchable-popover.types";

import { SearchablePopoverTrigger } from "./SearchablePopoverTrigger";

import { SearchablePopoverContent } from "./SearchablePopoverContent";

import { SearchablePopoverSearch } from "./SearchablePopoverSearch";


import { filterSearchableItems } from "./searchable-popover.utils";
import { SearchablePopoverList } from "./SearchablePopoverList";

export const SearchablePopoverSelect = <T,>({
    items,
    value = null,
    onChange,
    getKey,
    getSearchText,
    renderItem,
    renderValue,

    placeholder = "Select",
    label,
    searchPlaceholder = "Search...",
    emptyMessage = "No results found",

    disabled = false,
    loading = false,
    fullWidth = false,

    error = false,
    helperText,

    size = "small",
    variant = "outlined",

    sx,
}: SearchablePopoverSelectProps<T>) => {
    const [anchorEl, setAnchorEl] =
        useState<HTMLElement | null>(null);

    const [search, setSearch] = useState("");

    const open = Boolean(anchorEl);

    const filteredItems = useMemo(() => {
        return filterSearchableItems(
            items,
            search,
            getSearchText
        );
    }, [items, search, getSearchText]);

    const handleOpen = (
        event: MouseEvent<HTMLElement>
    ) => {
        if (disabled) {
            return;
        }

        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSearch("");
    };

    const handleSelect = (item: T) => {
        onChange(item);
        handleClose();
    };

    return (
        <>
            <SearchablePopoverTrigger
                value={value}
                renderValue={renderValue}
                placeholder={placeholder}
                label={label}
                disabled={disabled}
                fullWidth={fullWidth}
                error={error}
                helperText={helperText}
                size={size}
                variant={variant}
                onClick={handleOpen}
                sx={sx}
            />

            <SearchablePopoverContent
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                search={
                    <SearchablePopoverSearch
                        value={search}
                        placeholder={searchPlaceholder}
                        onChange={setSearch}
                        onClear={() => setSearch("")}
                    />
                }
            >
                <SearchablePopoverList
                    items={filteredItems}
                    selectedValue={value}
                    getKey={getKey}
                    renderItem={renderItem}
                    onSelect={handleSelect}
                    emptyMessage={emptyMessage}
                    loading={loading}
                />
            </SearchablePopoverContent>
        </>
    );
};